export type PostHearingTabId = "decision" | "legal" | "actions" | "documents" | "activity" | "closeout";

export type PostHearingActionStatus = "complete" | "in_progress" | "blocked" | "not_started" | "not_required";

export interface PostHearingActionRow {
  id: "decision" | "legal" | "documents" | "review" | "approval";
  label: string;
  description: string;
  statusCode: PostHearingActionStatus;
  statusLabel: string;
  owner: string;
  updatedUtc?: string | null;
  nextStep: string;
  actionLabel: string;
  targetTab: PostHearingTabId;
}

export function isResolvedPostHearingAction(action: PostHearingActionRow): boolean {
  return action.statusCode === "complete" || action.statusCode === "not_required";
}

export function isBlockingPostHearingAction(action: PostHearingActionRow): boolean {
  return !isResolvedPostHearingAction(action);
}
